import url from './url';



export default url(({ id }) => `/images/${id}/archive`);
